import { Button, Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ISelectFoodCategory } from '../../interface/interface';

interface Props { 
    foodCategory: string;
    selectCategories: ISelectFoodCategory[];
    selected: boolean;
    setSelectFoodCategories: React.Dispatch<React.SetStateAction<any>>;
}

const useStyles = makeStyles((theme: any) => ({
    foodCategoryButton: {
        border: '1px solid #999999',
        borderRadius: '50%',
        minWidth: '36px !important',
        width: '36px !important',
        height: '36px !important',
        marginRight: 15, 
    },  
    innerCircle:{
        background: '#FFFFFF',
        borderRadius: '50%',
        width: 10,
        height: 10
    }, 
    categoryTitle: {
        fontSize: 16,
        fontWeight: 400,
        color: '#374251'
    },
    selected:{
        background: "#6178ED"
    }
}));

export const CategoryCheckbox: React.FC<Props> = ({foodCategory,selectCategories,selected,setSelectFoodCategories}) => {
    // Styling
    const classes = useStyles();

    const updateFoodCategories = () => {
        const newCategories: ISelectFoodCategory[] = [];
        selected = !selected;

        selectCategories.forEach( (selectCategoryItem) => {
            if(selectCategoryItem.foodCategory=== foodCategory){
                selectCategoryItem.selected = selected;
            } 
            newCategories.push(selectCategoryItem)
        });
        setSelectFoodCategories(newCategories);
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
        >
            <Button className={clsx(classes.foodCategoryButton, selected && classes.selected)} onClick={() => updateFoodCategories()}>
                {selected ? <div className={classes.innerCircle}></div> : <div></div>}
            </Button>
            <div className={classes.categoryTitle}>
                {foodCategory}
            </div>
        </Grid>
    );
}